/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'

// Create Virtual Routes

const TermsOfServiceLazyImport = createFileRoute('/terms-of-service')()
const PrivacyPolicyLazyImport = createFileRoute('/privacy-policy')()
const PageNotFoundLazyImport = createFileRoute('/page-not-found')()
const MenuLazyImport = createFileRoute('/menu')()
const LocationAndContactLazyImport = createFileRoute('/location-and-contact')()

// Create/Update Routes

const TermsOfServiceLazyRoute = TermsOfServiceLazyImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/terms-of-service.lazy').then((d) => d.Route),
)

const PrivacyPolicyLazyRoute = PrivacyPolicyLazyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/privacy-policy.lazy').then((d) => d.Route),
)

const PageNotFoundLazyRoute = PageNotFoundLazyImport.update({
  id: '/page-not-found',
  path: '/page-not-found',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/page-not-found.lazy').then((d) => d.Route),
)

const MenuLazyRoute = MenuLazyImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/menu.lazy').then((d) => d.Route))

const LocationAndContactLazyRoute = LocationAndContactLazyImport.update({
  id: '/location-and-contact',
  path: '/location-and-contact',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/location-and-contact.lazy').then((d) => d.Route),
)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/location-and-contact': {
      id: '/location-and-contact'
      path: '/location-and-contact'
      fullPath: '/location-and-contact'
      preLoaderRoute: typeof LocationAndContactLazyImport
      parentRoute: typeof rootRoute
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuLazyImport
      parentRoute: typeof rootRoute
    }
    '/page-not-found': {
      id: '/page-not-found'
      path: '/page-not-found'
      fullPath: '/page-not-found'
      preLoaderRoute: typeof PageNotFoundLazyImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyLazyImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/location-and-contact': typeof LocationAndContactLazyRoute
  '/menu': typeof MenuLazyRoute
  '/page-not-found': typeof PageNotFoundLazyRoute
  '/privacy-policy': typeof PrivacyPolicyLazyRoute
  '/terms-of-service': typeof TermsOfServiceLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/location-and-contact': typeof LocationAndContactLazyRoute
  '/menu': typeof MenuLazyRoute
  '/page-not-found': typeof PageNotFoundLazyRoute
  '/privacy-policy': typeof PrivacyPolicyLazyRoute
  '/terms-of-service': typeof TermsOfServiceLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/location-and-contact': typeof LocationAndContactLazyRoute
  '/menu': typeof MenuLazyRoute
  '/page-not-found': typeof PageNotFoundLazyRoute
  '/privacy-policy': typeof PrivacyPolicyLazyRoute
  '/terms-of-service': typeof TermsOfServiceLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/location-and-contact'
    | '/menu'
    | '/page-not-found'
    | '/privacy-policy'
    | '/terms-of-service'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/location-and-contact'
    | '/menu'
    | '/page-not-found'
    | '/privacy-policy'
    | '/terms-of-service'
  id:
    | '__root__'
    | '/'
    | '/location-and-contact'
    | '/menu'
    | '/page-not-found'
    | '/privacy-policy'
    | '/terms-of-service'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocationAndContactLazyRoute: typeof LocationAndContactLazyRoute
  MenuLazyRoute: typeof MenuLazyRoute
  PageNotFoundLazyRoute: typeof PageNotFoundLazyRoute
  PrivacyPolicyLazyRoute: typeof PrivacyPolicyLazyRoute
  TermsOfServiceLazyRoute: typeof TermsOfServiceLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocationAndContactLazyRoute: LocationAndContactLazyRoute,
  MenuLazyRoute: MenuLazyRoute,
  PageNotFoundLazyRoute: PageNotFoundLazyRoute,
  PrivacyPolicyLazyRoute: PrivacyPolicyLazyRoute,
  TermsOfServiceLazyRoute: TermsOfServiceLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/location-and-contact",
        "/menu",
        "/page-not-found",
        "/privacy-policy",
        "/terms-of-service"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/location-and-contact": {
      "filePath": "location-and-contact.lazy.tsx"
    },
    "/menu": {
      "filePath": "menu.lazy.tsx"
    },
    "/page-not-found": {
      "filePath": "page-not-found.lazy.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.lazy.tsx"
    },
    "/terms-of-service": {
      "filePath": "terms-of-service.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
